module.exports = __webpack_public_path__ + "static/media/4.db6e7f2f.svg";